import { Login, Register, ForgetPwd, Agreement, About, Feedback, Search, Help, Teacher, TeacherDetail } from './'; // This is the JSON way to define React Router rules in a Rekit app.
// Learn more from: http://rekit.js.org/docs/routing.html
// This is the JSON way to define React Router rules in a Rekit app.
// Learn more from: http://rekit.js.org/docs/routing.html // This is the JSON way to define React Router rules in a Rekit app.
// Learn more from: http://rekit.js.org/docs/routing.html
// This is the JSON way to define React Router rules in a Rekit app.
// Learn more from: http://rekit.js.org/docs/routing.html

export default {
  path: 'common',
  name: 'Common',
  childRoutes: [
    { path: '/login', name: 'Login', component: Login },
    { path: '/register', name: 'Register', component: Register },
    { path: '/forgetpwd', name: 'Forget pwd', component: ForgetPwd },
    { path: '/agreement', name: 'Agreement', component: Agreement },
    { path: '/about', name: 'About', component: About },
    { path: '/feedback', name: 'Feedback', component: Feedback },
    { path: '/search', name: 'Search', component: Search },
    { path: '/help', name: 'Help', component: Help },
    { path: '/teachers', name: 'Teacher', component: Teacher },
    { path: '/teachers/detail/:id', name: 'Teacher detail', component: TeacherDetail },
  ],
};



// WEBPACK FOOTER //
// ./src/features/common/route.js